__turbopack_context__.v({
  "danger": "Option-module-scss-module__VaiDSa__danger",
  "focused": "Option-module-scss-module__VaiDSa__focused",
  "highlighted": "Option-module-scss-module__VaiDSa__highlighted",
  "option": "Option-module-scss-module__VaiDSa__option",
  "selected": "Option-module-scss-module__VaiDSa__selected",
});
